<template>
  <div class="student-take-rate-card">
    <!-- <div style="" class="gh-tutor">
      TUTOR
    </div> -->
    <v-tabs vertical class="custom-tab-join-rate" v-model="tab" hide-slider>
      <v-tab style="width: 150px; font-size: 12px;">
        <img src="../assets/studying_2.svg" height="20" width="20" alt="" class="mr-2">
        <span style="text-transform: none !important;">Bài luyện tập & tương tác</span></v-tab>
      <v-tab style="width: 150px; font-size: 12px;">
        <img src="../assets/working_3.svg" height="20" width="20" alt="" class="mr-2">
        <span style="text-transform: none !important;">Chuyên cần</span></v-tab>
      <v-tab style="width: 150px; font-size: 12px;">
        <img src="../assets/test_1.svg" height="20" width="20" alt="" class="mr-2">
        <span style="text-transform: none !important;">Kiểm tra</span> </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ExerciseTab></ExerciseTab>
        </v-tab-item>
        <v-tab-item>
          <AttendanceTab></AttendanceTab>
        </v-tab-item>
        <v-tab-item>
          <PeriodicInspectionTab></PeriodicInspectionTab>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import PeriodicInspectionTab from '@/modules/student_detail_bt/components/PeriodicInspectionTab.vue';
import ExerciseTab from '@/modules/student_detail_bt/components/ExerciseTab.vue';
import AttendanceTab from '@/modules/student_detail_bt/components/AttendanceTab.vue';

export default {
  name: 'TakePartInRate',
  components: {
    ExerciseTab,
    AttendanceTab,
    PeriodicInspectionTab,
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style lang="scss">
.custom-tab-join-rate .v-slide-group__content.v-tabs-bar__content {
  background: white;
}
.custom-tab-join-rate .v-tab.v-tab--active {
  background: #E3F0FF;
  color: black;
  filter: none;
}
.custom-tab-join-rate .v-tab {
  filter: grayscale(1);
  border-radius: 10px;
  max-width: 200px !important;
  justify-content: left;
  border-radius: 10px;
  background: #F8F7F7;
  margin-bottom: 12px;
}
.custom-tab-join-rate .v-slide-group__content {
  white-space: normal !important;
}
.student-take-rate-card {
  border-radius: 12px;
  width: 98%;
  padding: 16px;
  background: white;
}
.gh-tutor {
  font-size: 16px;
  margin-bottom: 12px;
  margin-left: 115px;
  text-align:center;
  border-radius: 16px ;
  margin-right: 12px;
  background: #CD91D7;
  padding: 4px 10px;
  color: white;
  width: fit-content;
  height: fit-content;
}
  @media screen and (max-width: 1440px) {
  .student-take-rate-card {
    font-size: 12px !important;
    span {
      font-size: 12px !important;
      // margin: auto;
    }
    .gh-tutor {
      font-size: 14px;
    }
  }
  }
</style>
